var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'vertical-radio': true,
        'vertical-radio--reversed': _vm.reversed }},[_c('h3',{staticClass:"vertical-radio__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('b-tabs',{attrs:{"vertical":"","card":"","nav-wrapper-class":"vertical-radio__nav","nav-class":"vertical-radio__items","content-class":"vertical-radio__content","end":_vm.reversed === true && _vm.viewportIsLarge}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }